import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {PictureAnnotationWidgetService} from '../../../../services/picture-annotation-widget.service';
import {TupleOfstringAndstring} from '../../../../api/api-client';
import {ScrollPanelModule} from 'primeng/scrollpanel';

@Component({
  selector: 'app-annotation-legend',
  imports: [
    InputTextModule,
    ReactiveFormsModule,
    FormsModule,
    ScrollPanelModule
  ],
  providers: [],
  templateUrl: './annotation-legend.component.html',
  styleUrl: './annotation-legend.component.scss'
})
export class AnnotationLegendComponent{
  // @Input() uniqueColors!: string[];
  @Input() documentLegendElements!:TupleOfstringAndstring[]|undefined;

  constructor(protected pawService: PictureAnnotationWidgetService) {
    // this.uniqueColors = [];
    this.pawService.legendEntries = [];
    if(this.documentLegendElements){
      for (let legendElement of this.documentLegendElements){
        this.pawService.legendEntries.push(legendElement);
      }
    }
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes["uniqueColors"]) {
  //     // step through each unique color
  //     for (let uniqueColor of changes["uniqueColors"].currentValue) {
  //       // if this color is not yet saved in our service and thus not shown in the UI
  //       if (this.pawService.legendEntries.findIndex(legendEntry => legendEntry.x == uniqueColor) == -1) {
  //         // Add the color to the service array
  //         if(this.documentLegendElements){
  //           var documentLegendElementIndex=this.documentLegendElements.findIndex(legendEntry => legendEntry.x == uniqueColor)
  //           if(documentLegendElementIndex !== -1) {
  //             this.pawService.legendEntries.push({x: uniqueColor, y: this.documentLegendElements[documentLegendElementIndex].y??""} as TupleOfstringAndstring);
  //           }
  //           else{
  //             this.pawService.legendEntries.push(<TupleOfstringAndstring>{x: uniqueColor, y: ""})
  //           }
  //         }
  //       }
  //     }
  //     // step through each color saved in the service array
  //     for(let i=0; i < this.pawService.legendEntries.length; i++) {
  //       // if there is a color not in the unique colors but in the service array,
  //       // that means that there is a deleted annotation color
  //       if((<string[]>changes["uniqueColors"].currentValue).findIndex(x=>x==this.pawService.legendEntries[i].x)==-1) {
  //         // delete the annotation
  //         this.pawService.legendEntries.splice(i,1);
  //       }
  //     }
  //   }
  // }


}
